import React from 'react';
import { Formik, Form, Field, FieldArray } from 'formik';
import { Grid, Box, Button, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createproductDispatch } from 'reducers/HomeReducer';

const ProfileForm = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { loginInfo } = useSelector((state) => state.home);
	const handleFormSubmit = (values) => {
		const formData = new FormData();
		formData.append('name', values.name);
		formData.append('product_type', values.product_type);
		formData.append('description', values.description);
		formData.append('price', values.price);
		formData.append('offer_price', values.offer_price);
		formData.append('features_image', values.features_image);
		dispatch(createproductDispatch(formData, loginInfo.token, navigate));
		console.log('values', values);
	};
	return (
		<Formik
			initialValues={{
				name: '',
				product_type: '',
				description: '',
				price: '',
				offer_price: '',
				features_image: ''
			}}
			onSubmit={handleFormSubmit}>
			{(formik) => {
				const { errors, setFieldValue } = formik;
				return (
					<Form>
						<Box style={{ padding: 10 }}>
							<Box
								style={{
									boxShadow:
										'rgba(0, 0, 0, 0.06) 0px 3px 3px -2px, rgba(0, 0, 0, 0.04) 0px 3px 4px 0px, rgba(0, 0, 0, 0.04) 0px 1px 8px 0px',
									padding: 30,
									background: 'white'
								}}>
								<h2>Add New Product</h2>
								<Divider style={{ marginTop: 20, marginBottom: 20 }} />
								<Grid container style={{ padding: 10 }} spacing={4}>
									<Grid item xs={12} lg={6}>
										<Field
											name='name'
											type='text'
											placeHolder='Name'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.name ? '2px solid red' : '1px solid',
												marginTop: 10
											}}
											inputProps={{
												style: { padding: 12 }
											}}
										/>
										<br />
										{errors?.name ? (
											<span style={{ color: 'red', fontSize: 12 }}>{errors?.name}</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											name='product_type'
											type='text'
											placeHolder='Product Type'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.product_type ? '2px solid red' : '1px solid',
												marginTop: 10
											}}
											inputProps={{
												style: { padding: 12 }
											}}
										/>
										<br />
										{errors?.product_type ? (
											<span style={{ color: 'red', fontSize: 12 }}>{errors?.product_type}</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											name='description'
											type='text'
											placeHolder='Description'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.description ? '2px solid red' : '1px solid',
												marginTop: 10
											}}
											inputProps={{
												style: { padding: 12 }
											}}
										/>
										<br />
										{errors?.description ? (
											<span style={{ color: 'red', fontSize: 12 }}>{errors?.description}</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											name='price'
											type='text'
											placeHolder='Price'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.price ? '2px solid red' : '1px solid',
												marginTop: 10
											}}
											inputProps={{
												style: { padding: 12 }
											}}
										/>
										<br />
										{errors?.price ? (
											<span style={{ color: 'red', fontSize: 12 }}>{errors?.price}</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											name='offer_price'
											type='text'
											placeHolder='Offer Price'
											style={{
												padding: 10,
												width: '100%',
												borderRadius: 5,
												border: errors?.offer_price ? '2px solid red' : '1px solid',
												marginTop: 10
											}}
											inputProps={{
												style: { padding: 12 }
											}}
										/>
										<br />
										{errors?.offer_price ? (
											<span style={{ color: 'red', fontSize: 12 }}>{errors?.offer_price}</span>
										) : null}
									</Grid>
									<Grid item xs={12} lg={6}>
										<input
											type='file'
											accept='image/*'
											style={{
												borderColor: errors.features_image ? 'red' : '',
												border: '1px dashed #E61855',
												padding: 62,
												width: '100%',
												borderRadius: 12
											}}
											name='features_image'
											id='image'
											className='form-control'
											onChange={(event) => {
												setFieldValue('features_image', event.currentTarget.files[0]);
											}}
										/>

										{errors.features_image ? (
											<span style={{ color: 'red', fontSize: 12 }}>{errors.features_image}</span>
										) : null}
									</Grid>

									<Grid item xs={12} lg={6}></Grid>
									<Grid item xs={12} lg={3}>
										<Button
											type='submit'
											style={{
												background: 'rgb(25, 118, 210)',
												color: 'white',
												marginTop: 30,
												// padding: 16,
												borderRadius: 5,
												width: '100%'
											}}>
											Add
										</Button>
									</Grid>
								</Grid>
							</Box>
						</Box>
					</Form>
				);
			}}
		</Formik>
	);
};

export default ProfileForm;
